<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="caseList !== null ? caseList.length > 0 : false">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="caseList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/cases/single/' + props.item.id)">{{props.item.title}}</span>
                </td>
                <td class="text-xs-left">{{ $moment(props.item.start_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">{{ $moment(props.item.end_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">{{ props.item.bonus_percent }} %</td>
                <td class="text-xs-left">{{ indicatorFormatting(props.item.bonus_max_sum) }} ₽</td>
                <td class="text-xs-left">
                  <div v-if="mode === 'active'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="editCase(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="deleteCase(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="mode === 'active' && caseList !== null ? caseList.length === 0 : false">
      <div class="ml-3 subheading">Нет активных кейсов. <span @click="$router.push('/cases/new')" class="cursor-pointer primary--text">Добавить новый</span></div>
    </div>

    <div v-if="mode === 'archive' && caseList !== null ? caseList.length === 0 : false">
      <div class="ml-3 subheading">Нет архивных кейсов.</div>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'active'"
    >
      <v-card>
        <v-card-title class="headline">Удалить кейс?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteCaseConfirm(deleteCaseId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteCaseCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Кейсы'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата начала действия',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата окончания',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: '% от продаж',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Максимальное вознаграждение',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          caseList: false
        },
        page: 1,
        mode: 'active',
        title: 'Активные кейсы',
        deleteDialog: false,
        deleteCaseId: null
      }
    },
    methods: {
      indicatorFormatting (val) {
        val = Math.round(parseFloat(val)).toString()
        let result = ''
        let i = 0
        val.split('').reverse().forEach(function (char) {
          if (i === 3) {
            result += ' '
            i = 1
          } else {
            i++
          }
          result += char
        })
        result = result.split('').reverse().join('')
        return result
      },
      pageDataStatus () {
        if (!this.pageDataReady.caseList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      changePage () {
        this.scrollUp()

        this.pageDataReady = {
          isReady: false,
          caseList: false
        }
        this.$store.commit('setPageLoading', true)

        if (this.mode === 'active') {
          this.$router.push('/cases/active/' + this.page)
        } else if (this.mode === 'archive') {
          this.$router.push('/cases/past/' + this.page)
        } else {
          this.$store.dispatch('getCaseList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
        }
      },
      editCase (id) {
        this.$router.push('/cases/edit/' + id)
      },
      deleteCase (id) {
        this.deleteDialog = true
        this.deleteCaseId = id
      },
      deleteCaseCancel () {
        this.deleteDialog = false
        this.deleteCaseId = null
      },
      async deleteCaseConfirm () {
        this.deleteDialog = false
        await this.$store.dispatch('deleteCase', {id: this.deleteCaseId})
        this.deleteCaseId = null
        await this.$store.dispatch('getCaseList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/cases/active')) {
          this.mode = 'active'
          this.title = 'Активные кейсы'
        } else if (~this.$router.currentRoute.path.indexOf('/cases/past')) {
          this.mode = 'archive'
          this.title = 'Архив кейсов'
        }
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getCaseList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
          .then(() => {
            this.pageDataReady.caseList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      caseList () {
        return this.$store.getters.caseList
      },
      totalCount () {
        return this.$store.getters.caseTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Cases/CaseList.vue